export default {
  /**
   * 是否为空
   * @param str 字符串
   */
  isBlank(str: string): boolean {
    return str == null || str.trim() === ''
  },
  /**
   * 是否非空
   * @param str 字符串
   */
  isNotBlank(str: string): boolean {
    return !this.isBlank(str)
  }
}